module.exports = __webpack_public_path__ + "img/layout-text-sidebar.4361b89a.svg";